import { EmployeePurchasedPlanForRenewComponent } from "./pages/new-v2-pages/employee-purchased-plan-for-renew/employee-purchased-plan-for-renew.component";
import { AdminPostDetailsComponent } from "./shared/components/admin-post-details/admin-post-details.component";
import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import {
  AngularFireAuthGuard,
  redirectLoggedInTo,
  redirectUnauthorizedTo,
} from "@angular/fire/auth-guard";
import { ActivityComponent } from "./pages/activity/activity.component";
import { NewLoginComponent } from "./pages/new-v2-pages/login/login.component";
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { PromotionComponent } from "./pages/promotion/promotion.component";
import { ReportComponent } from "./pages/report/report.component";
import { SubscriptionComponent } from "./pages/subscription/subscription.component";
import { SupportComponent } from "./pages/support/support.component";
import { AllUsersComponent } from "./pages/dashboard/all-users/all-users.component";
import { AllCountriesComponent } from "./pages/dashboard/all-countries/all-countries.component";
import { AllSupportRequestComponent } from "./pages/support/all-support-request/all-support-request.component";
import { AllUnblockRequestComponent } from "./pages/support/all-unblock-request/all-unblock-request.component";
import { AllAbuseReportComponent } from "./pages/activity/all-abuse-report/all-abuse-report.component";
import { AllDeactivatedAccountComponent } from "./pages/activity/all-deactivated-account/all-deactivated-account.component";
import { AllBusinessInfoComponent } from "./pages/subscription/all-business-info/all-business-info.component";
import { AllEmployeeInfoComponent } from "./pages/subscription/all-employee-info/all-employee-info.component";
import { AllTransactionInfoComponent } from "./pages/subscription/all-transaction-info/all-transaction-info.component";
import { AdminPostComponent } from "./pages/promotion/admin-post/admin-post.component";
import { AdvertisersComponent } from "./pages/promotion/advertisers/advertisers.component";
import { BusinessPromotionComponent } from "./pages/promotion/business-promotion/business-promotion.component";
import { TargetNotificationComponent } from "./pages/promotion/target-notification/target-notification.component";
import { CouponsComponent } from "./pages/promotion/coupons/coupons.component";
import { BusinessesComponent } from "./pages/businesses/businesses.component";
import { DocumentsComponent } from "./pages/businesses/documents/documents.component";
import { DetailsComponent } from "./pages/businesses/details/details.component";
import { ServicesComponent } from "./pages/businesses/services/services.component";
import { OnlinePaymentsComponent } from "./pages/businesses/online-payments/online-payments.component";
import { ServiceTemplatesComponent } from "./pages/service-templates/service-templates.component";
import { PaymentsComponent } from "./pages/businesses/online-payments/payments/payments.component";
import { EntityBusinessComponent } from "./pages/dashboard/entity-business/entity-business.component";
import { OnlineTransactionsComponent } from "./pages/businesses/online-payments/online-transactions/online-transactions.component";
import { BookingsComponent } from "./pages/businesses/bookings/bookings.component";
import { EmployeesComponent } from "./pages/businesses/employees/employees.component";
import { pathToFileURL } from "url";
import { ReferralComponent } from "./pages/referral/referral.component";
import { QrCodesComponent } from "./pages/qr-codes/qr-codes.component";
import { ProfileComponent } from "./pages/profile/profile.component";
import { AllMessagesComponent } from "./pages/dashboard/all-messages/all-messages.component";
import { AllNotificationsComponent } from "./pages/dashboard/all-notifications/all-notifications.component";
import { SearchComponent } from "./pages/search/search.component";
import { PurchasedPlansComponent } from "./pages/purchased-plans/purchased-plans.component";
import { PrivacyPolictyComponent } from "./pages/privacy-policty/privacy-policty.component";
import { TermsOfServiceComponent } from "./pages/terms-of-service/terms-of-service.component";
import { InviteFriendsComponent } from "./pages/invite-friends/invite-friends.component";
import { TaxandgstComponent } from "./pages/businesses/taxandgst/taxandgst.component";
import { DiscountsComponent } from "./pages/businesses/discounts/discounts.component";
import { BookingHistoryComponent } from "./pages/businesses/booking-history/booking-history.component";
import { ServiceTimingsComponent } from "./pages/businesses/service-timings/service-timings.component";
import { FeedbackComponent } from "./pages/businesses/feedback/feedback.component";
import { QrCodeComponent } from "./pages/businesses/qr-code/qr-code.component";
import { PlanAndRenewComponent } from "./pages/businesses/plan-and-renew/plan-and-renew.component";
import { PersonalProfileComponent } from "./pages/personal-profile/personal-profile.component";
import { PreviousEmployeesComponent } from "./pages/previous-employees/previous-employees.component";
import { EmployeeInvitationComponent } from "./pages/employee-invitation/employee-invitation.component";
import { EmployeeDetailsComponent } from "./pages/employee-details/employee-details.component";
import { EmployeeSalaryComponent } from "./pages/employee-salary/employee-salary.component";
import { EmployeeSalarySettingsComponent } from "./pages/employee-salary-settings/employee-salary-settings.component";
import { EmployeePayCreditsComponent } from "./pages/employee-pay-credits/employee-pay-credits.component";
import { EmployeeDutyLogsComponent } from "./pages/employee-duty-logs/employee-duty-logs.component";
import { EmployeeSubscriptionAndRenewComponent } from "./pages/employee-subscription-and-renew/employee-subscription-and-renew.component";
import { EmployeeInvitationDetailsComponent } from "./pages/employee-invitation-details/employee-invitation-details.component";
import { OwnerProfileComponent } from "./pages/owner-profile/owner-profile.component";
import { PhoneNumberChangeComponent } from "./pages/phone-number-change/phone-number-change.component";
import { PrivacySettingsComponent } from "./pages/privacy-settings/privacy-settings.component";
import { CustomersComponent } from "./pages/businesses/customers/customers.component";
import { CustomersAllBookingsComponent } from "./pages/businesses/customers-all-bookings/customers-all-bookings.component";
import { CustomersDueBookingsComponent } from "./pages/businesses/customers-due-bookings/customers-due-bookings.component";
import { LoginPageComponent } from "./pages/login/login-page/login-page.component";
import { ExpensesComponent } from "./pages/businesses/expenses/expenses.component";
import { InventoryComponent } from "./pages/businesses/inventory/inventory.component";
import { PurchaseListComponent } from "./pages/businesses/purchase-list/purchase-list.component";
import { PostComponent } from "./pages/businesses/post/post.component";
import { FolowersComponent } from "./pages/businesses/folowers/folowers.component";
import { ReportsComponent } from "./pages/businesses/reports/reports.component";
import { InventoryItemsComponent } from "./pages/inventory-items/inventory-items.component";
import { SalesReportComponent } from "./pages/businesses/reports/sales-report/sales-report.component";
import { EmployeePerformanceReportComponent } from "./pages/businesses/reports/employee-performance-report/employee-performance-report.component";
import { ExpenditureReportComponent } from "./pages/businesses/reports/expenditure-report/expenditure-report.component";
import { BookingsReportComponent } from "./pages/businesses/reports/bookings-report/bookings-report.component";
import { ServicePerformanceReportComponent } from "./pages/businesses/reports/service-performance-report/service-performance-report.component";
import { InvoicesReportComponent } from "./pages/businesses/reports/invoices-report/invoices-report.component";
import { OnlinePaymentsReportComponent } from "./pages/businesses/reports/online-payments-report/online-payments-report.component";
import { InventoryActivityReportComponent } from "./pages/businesses/reports/inventory-activity-report/inventory-activity-report.component";
import { PurchaseActivityReportComponent } from "./pages/businesses/reports/purchase-activity-report/purchase-activity-report.component";
import { ProfitAnalysisReportComponent } from "./pages/businesses/reports/profit-analysis-report/profit-analysis-report.component";
import { TaxCollectionReportComponent } from "./pages/businesses/reports/tax-collection-report/tax-collection-report.component";
import { EmployeeSalaryReportComponent } from "./pages/businesses/reports/employee-salary-report/employee-salary-report.component";
import { PublicPostsComponent } from "./pages/businesses/folowers/public-posts/public-posts.component";
import { PublicMediaComponent } from "./pages/businesses/folowers/public-media/public-media.component";
import { PlatformServicesComponent } from "./pages/platform-services/platform-services.component";
import { ShareComponent } from "./pages/share/share.component";
import { SupportTicketComponent } from "./pages/businesses/support-ticket/support-ticket.component";
import { SupportTicketDetailsComponent } from "./pages/businesses/support-ticket-details/support-ticket-details.component";
import { CreateBusinessComponent } from "./pages/create-business/create-business.component";
import { BusinessCouponsComponent } from "./pages/businesses/coupons/coupons.component";
import { PurchasedPlanComponent } from "./pages/new-v2-pages/purchased-plan/purchased-plan.component";
import { BusinessCreateComponent } from "./pages/new-v2-pages/business-create/business-create.component";
import { HomeComponent } from "./pages/new-v2-pages/home/home.component";
import { NewDashboardComponent } from "./pages/new-v2-pages/new-dashboard/new-dashboard.component";
import { AllTodayBookingsComponent } from "./pages/new-v2-pages/dashboard-view-all/all-today-bookings/all-today-bookings.component";
import { NewBusinessDetailsComponent } from "./pages/new-v2-pages/new-business-details/new-business-details.component";
import { BusinessDetailsOwnersComponent } from "./pages/new-v2-pages/business-details-owners/business-details-owners.component";
import { NewServicesComponent } from "./pages/new-v2-pages/new-services/new-services.component";
import { NewServiceHoursComponent } from "./pages/new-v2-pages/new-service-hours/new-service-hours.component";
import { NewBookingComponent } from "./pages/new-v2-pages/booking/new-booking/new-booking.component";
import { NewShowAllComponent } from "./pages/new-v2-pages/booking/new-show-all/new-show-all.component";
import { NewEmployeesComponent } from "./pages/new-v2-pages/new-employees/new-employees.component";
import { NewEmployeeDetailsComponent } from "./pages/new-v2-pages/new-employee-details/new-employee-details.component";
import { NewRechargesComponent } from "./pages/new-v2-pages/new-recharges/new-recharges.component";
import { EmployeesPurchasedPlanComponent } from "./pages/new-v2-pages/employees-purchased-plan/employees-purchased-plan.component";
import { NewAddNewEmployeeComponent } from "./pages/new-v2-pages/new-add-new-employee/new-add-new-employee.component";
import { EmployeePlansListComponent } from "./pages/new-v2-pages/employee-plans-list/employee-plans-list.component";
import { AllEmployeeLogComponent } from "./pages/new-v2-pages/dashboard-view-all/all-employee-log/all-employee-log.component";
import { AllExpenditureComponent } from "./pages/new-v2-pages/dashboard-view-all/all-expenditure/all-expenditure.component";
import { AllInventoryStatusComponent } from "./pages/new-v2-pages/dashboard-view-all/all-inventory-status/all-inventory-status.component";
import { AllLatestPurchaseComponent } from "./pages/new-v2-pages/dashboard-view-all/all-latest-purchase/all-latest-purchase.component";
import { AllUpcomingAppointmentsComponent } from "./pages/new-v2-pages/dashboard-view-all/all-upcoming-appointments/all-upcoming-appointments.component";
import { NewProduceBillComponent } from "./pages/new-v2-pages/booking/new-produce-bill/new-produce-bill.component";
import { NewCurrentPackRechargeComponent } from "./pages/new-v2-pages/new-current-pack-recharge/new-current-pack-recharge.component";
import { PurchasedPlanForRenewComponent } from "./pages/new-v2-pages/purchased-plan-for-renew/purchased-plan-for-renew.component";
import { PlansListForRenewComponent } from "./pages/new-v2-pages/plans-list-for-renew/plans-list-for-renew.component";
import { BusinessProfileComponent } from "./pages/new-v2-pages/business-profile/business-profile.component";
import { EmployeeCurrentPackRechargeComponent } from "./pages/new-v2-pages/employee-current-pack-recharge/employee-current-pack-recharge.component";
import { EmployeePlansListForRenewComponent } from "./pages/new-v2-pages/employee-plans-list-for-renew/employee-plans-list-for-renew.component";
import { JoiningQueryListComponent } from "./pages/new-v2-pages/joining-query-list/joining-query-list.component";
import { MembersComponent } from "./pages/businesses/members/members.component";
import { MembersAllPaymentsComponent } from "./pages/businesses/members-all-payments/members-all-payments.component";
import { MembersDuePaymentsComponent } from "./pages/businesses/members-due-payments/members-due-payments.component";
import { ConfigureTaxGstComponent } from "./pages/new-v2-pages/configure-tax-gst/configure-tax-gst.component";
import { ConfigureOnlinePaymentComponent } from "./pages/new-v2-pages/configure-online-payment/configure-online-payment.component";
import { ConfigureDiscountComponent } from "./pages/new-v2-pages/configure-discount/configure-discount.component";
import { AddNewTaxComponent } from "./pages/new-v2-pages/add-new-tax/add-new-tax.component";
import { EntityProductsComponent } from "./pages/new-v2-pages/entity-products/entity-products.component";
import { MemberDetailsComponent } from "./pages/new-v2-pages/member-details/member-details.component";
import { MembershipReportComponent } from "./pages/businesses/reports/membership-report/membership-report.component";
import { ViewAttendanceComponent } from "./pages/new-v2-pages/view-attendance/view-attendance.component";
import { CustomersViewDetailsComponentForDet } from "./pages/businesses/customers-view-details/customers-view-details.component";
import { CustomerAllPaymentsComponent } from "./pages/businesses/customer-all-payments/customer-all-payments.component";
import { EmployeesProfileComponent } from "./pages/new-v2-pages/employees-profile/employees-profile.component";
import { EmployeeOnlyMySalaryComponent } from "./pages/new-v2-pages/employee-only-my-salary/employee-only-my-salary.component";
import { EmployeeOnlyMyCreditsComponent } from "./pages/new-v2-pages/employee-only-my-credits/employee-only-my-credits.component";
import { EmployeeOnlyMyAttendanceComponent } from "./pages/new-v2-pages/employee-only-my-attendance/employee-only-my-attendance.component";
import { EmployeeOnlyInvitationDetailsComponent } from "./pages/new-v2-pages/employee-only-invitation-details/employee-only-invitation-details.component";
import { TestComponent } from "./pages/new-v2-pages/test/test.component";
import { EntityUnavailabilityComponent } from "./pages/new-v2-pages/entity-unavailability/entity-unavailability.component";
import { AllCustomersComponent } from "./pages/new-v2-pages/all-customers/all-customers.component";
import { AllMembersComponent } from "./pages/new-v2-pages/all-members/all-members.component";
import { PromotionCampaignComponent } from "./pages/new-v2-pages/promotion-campaign/promotion-campaign.component";
import { BookingDetailsPageComponent } from "./pages/new-v2-pages/booking-details-page/booking-details-page.component";
import { MembershipBookingDetailsPageComponent } from "./pages/new-v2-pages/membership-booking-details-page/membership-booking-details-page.component";
import { JoiningInterestDetailsComponent } from "./pages/new-v2-pages/new-v2-component/joining-interest-details/joining-interest-details.component";
import { CreatePromotionCampaignComponent } from "./pages/new-v2-pages/new-v2-component/create-promotion-campaign/create-promotion-campaign.component";
import { ShareCustomerAppComponent } from "./pages/new-v2-pages/share-customer-app/share-customer-app.component";
import { TrackingItemsComponent } from "./pages/new-v2-pages/tracking-items/tracking-items.component";
import { TrackingItemsDetailsComponent } from "./pages/new-v2-pages/tracking-items-details/tracking-items-details.component";
import { AccessControlComponent } from "./pages/new-v2-pages/access-control/access-control.component";
import { CustomerWalletMoneyComponent } from "./pages/new-v2-pages/new-v2-component/customer-wallet-money/customer-wallet-money.component";
import { ServiceQueryDetailsPageComponent } from "./pages/new-v2-pages/new-v2-component/service-query-details-page/service-query-details-page.component";
import { LoyaltyConfigurerComponent } from "./pages/new-v2-pages/loyalty-configurer/loyalty-configurer.component";
import { RewardPointsComponent } from "./pages/businesses/reward-points/reward-points.component";
import { ServiceReminderComponent } from "./pages/new-v2-pages/service-reminder/service-reminder.component";
import { CustomerDetailsComponent } from "./pages/new-v2-pages/customer-details/customer-details.component";
import { AllUnpaidInvoicesComponent } from "./pages/new-v2-pages/dashboard-view-all/all-unpaid-invoices/all-unpaid-invoices.component";
import { EnrollNewMemberComponent } from "./pages/new-v2-pages/enroll-new-member/enroll-new-member.component";

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(["login"]);
const redirectLoggedInToDashboard = () => redirectLoggedInTo(["dashboard"]);

const routes: Routes = [
  {
    path: "login",
    component: NewLoginComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToDashboard },
  },
  {
    path: "registration",
    component: PersonalProfileComponent,
  },
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "dashboard",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: NewDashboardComponent,
      },
      {
        path: "booking-details",
        children: [
          {
            path: "",
            component: BookingDetailsPageComponent,
          },
          {
            path: "customer-details",
            children: [
              {
                path: "",
                component: CustomerDetailsComponent,
              },
              {
                path: "customer-wallet-money",
                component: CustomerWalletMoneyComponent,
              },
              {
                path: "all-bookings",
                children: [
                  {
                    path: "",
                    component: CustomersAllBookingsComponent,
                  },
                  {
                    path: "booking-details", //dont consider this in loop chain
                    component: BookingDetailsPageComponent,
                  },
                ],
              },

              {
                path: "all-payments",
                component: CustomerAllPaymentsComponent,
              },
              {
                path: "due-bookings",
                component: CustomersDueBookingsComponent,
              },
              {
                path: "reward-points",
                component: RewardPointsComponent,
              },
              // {
              //   path: 'unavailability',
              //   component: EntityUnavailabilityComponent
              // }
            ],
          },
        ],
      },
      {
        path: "membership-booking-details",
        children: [
          {
            path: "",
            component: MembershipBookingDetailsPageComponent,
          },
          {
            path: "tracking-item",
            children: [
              {
                path: "",
                component: TrackingItemsComponent,
              },
              {
                path: "tracking-item-details",
                component: TrackingItemsDetailsComponent,
              },
            ],
          },
          {
            path: "member-details",
            children: [
              {
                path: "",
                component: MemberDetailsComponent,
              },
              {
                path: "tracking-item",
                children: [
                  {
                    path: "",
                    component: TrackingItemsComponent,
                  },
                  {
                    path: "tracking-item-details",
                    component: TrackingItemsDetailsComponent,
                  },
                ],
              },
              {
                path: "customer-wallet-money",
                component: CustomerWalletMoneyComponent,
              },
              {
                path: "all-payments",
                component: MembersAllPaymentsComponent,
              },
              {
                path: "due-payments",
                component: MembersDuePaymentsComponent,
              },
              {
                path: "view-attendance",
                component: ViewAttendanceComponent,
              },
              {
                path: "reward-points",
                component: RewardPointsComponent,
              },
            ],
          },
        ],
      },
      {
        path: "query-details",
        component: JoiningInterestDetailsComponent,
      },
    ],
  },
  {
    path: "auto-login",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: TestComponent,
      },
    ],
  },
  // {
  //   path: 'dashboard',
  //   canActivate: [AngularFireAuthGuard],
  //   data: { authGuardPipe: redirectUnauthorizedToLogin },
  //   children: [
  //     {
  //       path: '',
  //       component: DashboardComponent,
  //     },

  //   ],
  // },
  {
    path: "profile",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: ProfileComponent,
      },
    ],
  },
  {
    path: "businesses",

    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: BusinessesComponent,
      },
      {
        path: "details",
        children: [
          {
            path: "",
            component: NewBusinessDetailsComponent,
          },
          {
            path: "promotion-campaign",
            children: [
              {
                path: "",
                component: PromotionCampaignComponent,
              },
              {
                path: "create-new-campaign",
                component: CreatePromotionCampaignComponent,
              },
            ],
          },

          {
            path: "extended-details",
            component: BusinessDetailsOwnersComponent,
          },
          {
            path: "bookings",
            children: [
              {
                path: "",
                component: BookingsComponent,
              },
              {
                path: "booking-details",
                children: [
                  {
                    path: "",
                    component: BookingDetailsPageComponent,
                  },
                  {
                    path: "customer-details",
                    children: [
                      {
                        path: "",
                        component: CustomerDetailsComponent,
                      },
                      {
                        path: "customer-wallet-money",
                        component: CustomerWalletMoneyComponent,
                      },
                      {
                        path: "all-bookings",
                        children: [
                          {
                            path: "",
                            component: CustomersAllBookingsComponent,
                          },
                          {
                            path: "booking-details", //dont consider this in loop chain
                            component: BookingDetailsPageComponent,
                          },
                        ],
                      },

                      {
                        path: "all-payments",
                        component: CustomerAllPaymentsComponent,
                      },
                      {
                        path: "due-bookings",
                        component: CustomersDueBookingsComponent,
                      },
                      {
                        path: "reward-points",
                        component: RewardPointsComponent,
                      },
                      // {
                      //   path: 'unavailability',
                      //   component: EntityUnavailabilityComponent
                      // }
                    ],
                  },
                ],
              },

              {
                path: "query-details",
                component: JoiningInterestDetailsComponent,
              },
              {
                path: "service-query-details",
                component: ServiceQueryDetailsPageComponent,
              },
            ],
          },
          {
            path: "joining-query-list",
            children: [
              {
                path: "",
                component: JoiningQueryListComponent,
              },
              {
                path: "booking-details",
                children: [
                  {
                    path: "",
                    component: BookingDetailsPageComponent,
                  },
                  {
                    path: "customer-details",
                    children: [
                      {
                        path: "",
                        component: CustomerDetailsComponent,
                      },
                      {
                        path: "customer-wallet-money",
                        component: CustomerWalletMoneyComponent,
                      },
                      {
                        path: "all-bookings",
                        children: [
                          {
                            path: "",
                            component: CustomersAllBookingsComponent,
                          },
                          {
                            path: "booking-details", //dont consider this in loop chain
                            component: BookingDetailsPageComponent,
                          },
                        ],
                      },

                      {
                        path: "all-payments",
                        component: CustomerAllPaymentsComponent,
                      },
                      {
                        path: "due-bookings",
                        component: CustomersDueBookingsComponent,
                      },
                      {
                        path: "reward-points",
                        component: RewardPointsComponent,
                      },
                      // {
                      //   path: 'unavailability',
                      //   component: EntityUnavailabilityComponent
                      // }
                    ],
                  },
                ],
              },
              {
                path: "membership-booking-details",
                children: [
                  {
                    path: "",
                    component: MembershipBookingDetailsPageComponent,
                  },
                  {
                    path: "tracking-item",
                    children: [
                      {
                        path: "",
                        component: TrackingItemsComponent,
                      },
                      {
                        path: "tracking-item-details",
                        component: TrackingItemsDetailsComponent,
                      },
                    ],
                  },
                  {
                    path: "member-details",
                    children: [
                      {
                        path: "",
                        component: MemberDetailsComponent,
                      },
                      {
                        path: "tracking-item",
                        children: [
                          {
                            path: "",
                            component: TrackingItemsComponent,
                          },
                          {
                            path: "tracking-item-details",
                            component: TrackingItemsDetailsComponent,
                          },
                        ],
                      },
                      {
                        path: "customer-wallet-money",
                        component: CustomerWalletMoneyComponent,
                      },
                      {
                        path: "all-payments",
                        component: MembersAllPaymentsComponent,
                      },
                      {
                        path: "due-payments",
                        component: MembersDuePaymentsComponent,
                      },
                      {
                        path: "view-attendance",
                        component: ViewAttendanceComponent,
                      },
                      {
                        path: "reward-points",
                        component: RewardPointsComponent,
                      },
                    ],
                  },
                ],
              },
              {
                path: "query-details",
                component: JoiningInterestDetailsComponent,
              },
              {
                path: "service-query-details",
                component: ServiceQueryDetailsPageComponent,
              },
            ],
          },
          {
            path: "tax-and-gst",
            children: [
              {
                path: "",
                component: TaxandgstComponent,
              },
              {
                path: "configure-tax-gst",
                children: [
                  {
                    path: "",
                    component: ConfigureTaxGstComponent,
                  },
                  {
                    path: "add-new-tax",
                    component: AddNewTaxComponent,
                  },
                ],
              },
            ],
          },

          {
            path: "discount",
            children: [
              {
                path: "",
                component: DiscountsComponent,
              },
              {
                path: "configure-discount",
                component: ConfigureDiscountComponent,
              },
            ],
          },

          {
            path: "coupons",
            component: BusinessCouponsComponent,
          },
          {
            path: "my-salary",
            component: EmployeeOnlyMySalaryComponent,
          },
          {
            path: "my-credits",
            component: EmployeeOnlyMyCreditsComponent,
          },
          {
            path: "my-attendance",
            component: EmployeeOnlyMyAttendanceComponent,
          },
          {
            path: "online-payments",
            children: [
              {
                path: "",
                component: OnlinePaymentsComponent,
              },
              {
                path: "configure-online-payment",
                component: ConfigureOnlinePaymentComponent,
              },
            ],
          },
          {
            path: "booking-history",
            children: [
              {
                path: "",
                component: BookingHistoryComponent,
              },
              {
                path: "booking-details",
                children: [
                  {
                    path: "",
                    component: BookingDetailsPageComponent,
                  },
                  {
                    path: "customer-details",
                    children: [
                      {
                        path: "",
                        component: CustomerDetailsComponent,
                      },
                      {
                        path: "customer-wallet-money",
                        component: CustomerWalletMoneyComponent,
                      },
                      {
                        path: "all-bookings",
                        children: [
                          {
                            path: "",
                            component: CustomersAllBookingsComponent,
                          },
                          {
                            path: "booking-details", //dont consider this in loop chain
                            component: BookingDetailsPageComponent,
                          },
                        ],
                      },

                      {
                        path: "all-payments",
                        component: CustomerAllPaymentsComponent,
                      },
                      {
                        path: "due-bookings",
                        component: CustomersDueBookingsComponent,
                      },
                      {
                        path: "reward-points",
                        component: RewardPointsComponent,
                      },
                      {
                        path: "service-reminder",
                        component: ServiceReminderComponent,
                      },
                      // {
                      //   path: 'unavailability',
                      //   component: EntityUnavailabilityComponent
                      // }
                    ],
                  },
                ],
              },
              {
                path: "service-reminder",
                component: ServiceReminderComponent,
              },
              {
                path: "query-details",
                component: JoiningInterestDetailsComponent,
              },
              {
                path: "service-query-details",
                component: ServiceQueryDetailsPageComponent,
              },
            ],
          },
          {
            path: "services",
            component: ServicesComponent,
          },
          {
            path: "products",
            component: EntityProductsComponent,
          },
          {
            path: "support-ticket",
            children: [
              {
                path: "",
                component: SupportTicketComponent,
              },
              {
                path: "support-ticket-details",
                component: SupportTicketDetailsComponent,
              },
            ],
          },
          {
            path: "customers",
            children: [
              {
                path: "",
                component: CustomersComponent,
              },
              {
                path: "customer-wallet-money",
                component: CustomerWalletMoneyComponent,
              },

              {
                path: "all-bookings",
                children: [
                  {
                    path: "",
                    component: CustomersAllBookingsComponent,
                  },
                  {
                    path: "booking-details",
                    children: [
                      {
                        path: "",
                        component: BookingDetailsPageComponent,
                      },
                      {
                        path: "customer-details",
                        children: [
                          {
                            path: "",
                            component: CustomerDetailsComponent,
                          },
                          {
                            path: "customer-wallet-money",
                            component: CustomerWalletMoneyComponent,
                          },
                          {
                            path: "all-bookings",
                            children: [
                              {
                                path: "",
                                component: CustomersAllBookingsComponent,
                              },
                              {
                                path: "booking-details", //dont consider this in loop chain
                                component: BookingDetailsPageComponent,
                              },
                            ],
                          },

                          {
                            path: "all-payments",
                            component: CustomerAllPaymentsComponent,
                          },
                          {
                            path: "due-bookings",
                            component: CustomersDueBookingsComponent,
                          },
                          {
                            path: "reward-points",
                            component: RewardPointsComponent,
                          },
                          // {
                          //   path: 'unavailability',
                          //   component: EntityUnavailabilityComponent
                          // }
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: "customer-details",
                children: [
                  {
                    path: "",
                    component: CustomerDetailsComponent,
                  },
                  {
                    path: "customer-wallet-money",
                    component: CustomerWalletMoneyComponent,
                  },
                  {
                    path: "all-bookings",
                    children: [
                      {
                        path: "",
                        component: CustomersAllBookingsComponent,
                      },
                      {
                        path: "booking-details", //dont consider this
                        component: BookingDetailsPageComponent,
                      },
                    ],
                  },

                  {
                    path: "all-payments",
                    component: CustomerAllPaymentsComponent,
                  },
                  {
                    path: "due-bookings",
                    component: CustomersDueBookingsComponent,
                  },
                  {
                    path: "reward-points",
                    component: RewardPointsComponent,
                  },
                  // {
                  //   path: 'unavailability',
                  //   component: EntityUnavailabilityComponent
                  // }
                ],
              },

              {
                path: "all-payments",
                component: CustomerAllPaymentsComponent,
              },
              {
                path: "due-bookings",
                component: CustomersDueBookingsComponent,
              },
              {
                path: "customers-view-details",
                component: CustomersViewDetailsComponentForDet,
              },
              {
                path: "reward-points",
                component: RewardPointsComponent,
              },
            ],
          },
          {
            path: "members",
            children: [
              {
                path: "",
                component: MembersComponent,
              },
              {
                path: "all-payments",
                component: MembersAllPaymentsComponent,
              },
              {
                path: "due-payments",
                component: MembersDuePaymentsComponent,
              },
              {
                path: "member-details",
                children: [
                  {
                    path: "",
                    component: MemberDetailsComponent,
                  },
                  {
                    path: "tracking-item",
                    children: [
                      {
                        path: "",
                        component: TrackingItemsComponent,
                      },
                      {
                        path: "tracking-item-details",
                        component: TrackingItemsDetailsComponent,
                      },
                    ],
                  },
                  {
                    path: "customer-wallet-money",
                    component: CustomerWalletMoneyComponent,
                  },
                  {
                    path: "all-payments",
                    component: MembersAllPaymentsComponent,
                  },
                  {
                    path: "due-payments",
                    component: MembersDuePaymentsComponent,
                  },
                  {
                    path: "view-attendance",
                    component: ViewAttendanceComponent,
                  },
                  {
                    path: "reward-points",
                    component: RewardPointsComponent,
                  },
                ],
              },
              {
                path: "view-attendance",
                component: ViewAttendanceComponent,
              },
            ],
          },
          {
            path: "service-timings",
            children: [
              {
                path: "",
                component: ServiceTimingsComponent,
              },
              {
                path: "unavailability",
                component: EntityUnavailabilityComponent,
              },
            ],
          },

          {
            path: "documents",
            component: DocumentsComponent,
          },
          {
            path: "feedback",
            component: FeedbackComponent,
          },
          {
            path: "all-invoices",
            component: InvoicesReportComponent,
          },
          {
            path: "qr-code",
            component: QrCodeComponent,
          },
          {
            path: "plan-and-renew",
            children: [
              {
                path: "",
                component: NewCurrentPackRechargeComponent,
              },
              {
                path: "purchased-plans",
                component: PurchasedPlanForRenewComponent,
              },
              {
                path: "plans-list",
                component: PlansListForRenewComponent,
              },
            ],
          },
          {
            path: "employees",
            children: [
              {
                path: "",
                component: EmployeesComponent,
              },
              {
                path: "invitation-details",
                component: EmployeeInvitationDetailsComponent,
              },
              {
                path: "employee-details",
                children: [
                  {
                    path: "",
                    component: EmployeeDetailsComponent,
                  },
                  {
                    path: "salary",
                    component: EmployeeSalaryComponent,
                  },
                  {
                    path: "salary-settings",
                    component: EmployeeSalarySettingsComponent,
                  },
                  {
                    path: "pay-credits",
                    component: EmployeePayCreditsComponent,
                  },
                  {
                    path: "duty-logs",
                    component: EmployeeDutyLogsComponent,
                  },
                  {
                    path: "access-control",
                    component: AccessControlComponent,
                  },
                  {
                    path: "current-plan",
                    children: [
                      {
                        path: "",
                        component: EmployeeCurrentPackRechargeComponent,
                      },
                      {
                        path: "purchased-plan",
                        children: [
                          {
                            path: "",
                            component: EmployeePurchasedPlanForRenewComponent,
                          },
                        ],
                      },
                      {
                        path: "plans-list",
                        children: [
                          {
                            path: "",
                            component: EmployeePlansListForRenewComponent,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: "previous-employees",
                component: PreviousEmployeesComponent,
              },
              {
                path: "employee-invitation",
                children: [
                  {
                    path: "",
                    component: EmployeeInvitationComponent,
                  },
                  {
                    path: "invitation-details",
                    component: EmployeeInvitationDetailsComponent,
                  },
                ],
              },
              {
                path: "purchased-plan",
                children: [
                  {
                    path: "",
                    component: EmployeesPurchasedPlanComponent,
                  },
                ],
              },
              {
                path: "plans-list",
                children: [
                  {
                    path: "",
                    component: EmployeePlansListComponent,
                  },
                ],
              },
              {
                path: "employee",
                children: [
                  {
                    path: "",
                    component: NewAddNewEmployeeComponent,
                  },
                ],
              },
            ],
          },
          {
            path: "expenses",
            component: ExpensesComponent,
          },
          {
            path: "inventory",
            children: [
              {
                path: "",
                component: InventoryComponent,
              },
              {
                path: "inventory-items",
                component: InventoryItemsComponent,
              },
            ],
          },
          {
            path: "purchase-list",
            component: PurchaseListComponent,
          },
          {
            path: "post",
            component: PostComponent,
          },
          {
            path: "followers",
            children: [
              {
                path: "",
                component: FolowersComponent,
              },
              {
                path: "public-posts",
                component: PublicPostsComponent,
              },
              {
                path: "public-media",
                component: PublicMediaComponent,
              },
            ],
          },

          {
            path: "loyalty-configurer",
            component: LoyaltyConfigurerComponent,
          },

          {
            path: "reports",
            children: [
              {
                path: "",
                component: ReportsComponent,
              },
              {
                path: "sales-report",
                component: SalesReportComponent,
              },
              {
                path: "membership-report",
                component: MembershipReportComponent,
              },
              {
                path: "employee-sales-report",
                component: EmployeePerformanceReportComponent,
              },
              {
                path: "expenditure-report",
                component: ExpenditureReportComponent,
              },
              {
                path: "employee-salary-report",
                component: EmployeeSalaryReportComponent,
              },
              {
                path: "booking-report",
                component: BookingsReportComponent,
              },
              {
                path: "service-report",
                component: ServicePerformanceReportComponent,
              },
              {
                path: "invoice-report",
                component: InvoicesReportComponent,
              },
              {
                path: "online-payments-report",
                component: OnlinePaymentsReportComponent,
              },
              {
                path: "inventory-activity-report",
                component: InventoryActivityReportComponent,
              },
              {
                path: "purchase-report",
                component: PurchaseActivityReportComponent,
              },
              {
                path: "profit-analysis-report",
                component: ProfitAnalysisReportComponent,
              },
              {
                path: "tax-collection-report",
                component: TaxCollectionReportComponent,
              },
            ],
          },
        ],
      },
      {
        path: "services",
        component: ServicesComponent,
      },

      {
        path: "bookings",
        component: BookingsComponent,
      },
      {
        path: "employees",
        component: EmployeesComponent,
      },

      {
        path: "onlinePayments",
        // component: OnlinePaymentsComponent,
        children: [
          {
            path: "",
            component: OnlinePaymentsComponent,
          },
          {
            path: "transfer-history",
            component: PaymentsComponent,
          },
          {
            path: "online-transactions",
            component: OnlineTransactionsComponent,
          },
        ],
      },
    ],
  },
  {
    path: "messages",

    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: AllMessagesComponent,
      },
    ],
  },
  {
    path: "notifications",

    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: AllNotificationsComponent,
      },
    ],
  },
  {
    path: "search",

    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: SearchComponent,
      },
    ],
  },
  {
    path: "purchased-plans",

    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: PurchasedPlansComponent,
      },
    ],
  },
  {
    path: "contact-us",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: SupportComponent,
      },
    ],
  },
  // {
  //   path: 'platform-services',
  //   canActivate: [AngularFireAuthGuard],
  //   data: { authGuardPipe: redirectUnauthorizedToLogin },
  //   children: [
  //     {
  //       path: '',
  //       component: PlatformServicesComponent,
  //     },

  //   ],
  // },
  {
    path: "privacy-policy",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: PrivacyPolictyComponent,
      },
    ],
  },

  {
    path: "terms-of-service",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: TermsOfServiceComponent,
      },
    ],
  },
  {
    path: "download-app",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: InviteFriendsComponent,
      },
    ],
  },

  {
    path: "report",
    component: ReportComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: "share-friends",
    component: ShareComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: "share-customer-app",
    component: ShareCustomerAppComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: "owner-profile",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: OwnerProfileComponent,
      },
    ],
  },
  {
    path: "phone-number-change",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: PhoneNumberChangeComponent,
      },
    ],
  },
  {
    path: "privacy-settings",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: PrivacySettingsComponent,
      },
    ],
  },

  {
    path: "plans-list",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: CreateBusinessComponent,
      },
    ],
  },
  {
    path: "business-create",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: BusinessCreateComponent,
      },
    ],
  },
  {
    path: "purchased-plan",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: PurchasedPlanComponent,
      },
    ],
  },

  {
    path: "home",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: HomeComponent,
      },
    ],
  },

  {
    path: "all-today-bookings",
    children: [
      {
        path: "",
        component: AllTodayBookingsComponent,
      },
      {
        path: "booking-details",
 children:[
          {
            path: '',
            component: BookingDetailsPageComponent,
          },
          {
                path: "customer-details",
                children: [
                  {
                    path: "",
                    component: CustomerDetailsComponent,
                  },
                  {
                    path: "customer-wallet-money",
                    component: CustomerWalletMoneyComponent,
                  },
                  {
                    path: "all-bookings",
                    children: [
                      {
                        path: "",
                        component: CustomersAllBookingsComponent,
                      },
                      {
                        path: "booking-details",//dont consider this in loop chain
                        component: BookingDetailsPageComponent,
                      },
                    ],
                  },

                  {
                    path: "all-payments",
                    component: CustomerAllPaymentsComponent,
                  },
                  {
                    path: "due-bookings",
                    component: CustomersDueBookingsComponent,
                  },
                  {
                    path: "reward-points",
                    component: RewardPointsComponent,
                  },
                  // {
                  //   path: 'unavailability',
                  //   component: EntityUnavailabilityComponent
                  // }
                ],
              },
        ]      },
      {
        path: "membership-booking-details",
        children: [
          {
            path: "",
            component: MembershipBookingDetailsPageComponent,
          },
          {
            path: "tracking-item",
            children: [
              {
                path: "",
                component: TrackingItemsComponent,
              },
              {
                path: "tracking-item-details",
                component: TrackingItemsDetailsComponent,
              },
            ],
          },
          {
            path: "member-details",
            children: [
              {
                path: "",
                component: MemberDetailsComponent,
              },
              {
                path: "tracking-item",
                children: [
                  {
                    path: "",
                    component: TrackingItemsComponent,
                  },
                  {
                    path: "tracking-item-details",
                    component: TrackingItemsDetailsComponent,
                  },
                ],
              },
              {
                path: "customer-wallet-money",
                component: CustomerWalletMoneyComponent,
              },
              {
                path: "all-payments",
                component: MembersAllPaymentsComponent,
              },
              {
                path: "due-payments",
                component: MembersDuePaymentsComponent,
              },
              {
                path: "view-attendance",
                component: ViewAttendanceComponent,
              },
              {
                path: "reward-points",
                component: RewardPointsComponent,
              },
            ],
          },
        ],
      },
      {
        path: "query-details",
        component: JoiningInterestDetailsComponent,
      },
    ],
  },
  {
    path: "all-unpaid-invoices",
    children: [
      {
        path: "",
        component: AllUnpaidInvoicesComponent,
      },
    ],
  },

  // {
  //   path: 'new-business-details',
  //   canActivate: [AngularFireAuthGuard],
  //   data: { authGuardPipe: redirectUnauthorizedToLogin },
  //   children: [
  //     {
  //       path: '',
  //       component: NewBusinessDetailsComponent,
  //     },

  //   ],
  // },

  {
    path: "business-details-owners",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: BusinessDetailsOwnersComponent,
      },
    ],
  },

  {
    path: "service-list",
    children: [
      {
        path: "",
        component: NewServicesComponent,
      },
    ],
  },

  {
    path: "business-hours",
    children: [
      {
        path: "",
        component: NewServiceHoursComponent,
      },
      {
        path: "unavailability",
        component: EntityUnavailabilityComponent,
      },
    ],
  },
  {
    path: "all-customers",
    children: [
      {
        path: "",
        component: AllCustomersComponent,
      },
      {
        path: "customer-wallet-money",
        component: CustomerWalletMoneyComponent,
      },
      {
        path: "all-bookings",
        children: [
          {
            path: "",
            component: CustomersAllBookingsComponent,
          },
          {
            path: "booking-details",
 children:[
          {
            path: '',
            component: BookingDetailsPageComponent,
          },
          {
                path: "customer-details",
                children: [
                  {
                    path: "",
                    component: CustomerDetailsComponent,
                  },
                  {
                    path: "customer-wallet-money",
                    component: CustomerWalletMoneyComponent,
                  },
                  {
                    path: "all-bookings",
                    children: [
                      {
                        path: "",
                        component: CustomersAllBookingsComponent,
                      },
                      {
                        path: "booking-details",//dont consider this in loop chain
                        component: BookingDetailsPageComponent,
                      },
                    ],
                  },

                  {
                    path: "all-payments",
                    component: CustomerAllPaymentsComponent,
                  },
                  {
                    path: "due-bookings",
                    component: CustomersDueBookingsComponent,
                  },
                  {
                    path: "reward-points",
                    component: RewardPointsComponent,
                  },
                  // {
                  //   path: 'unavailability',
                  //   component: EntityUnavailabilityComponent
                  // }
                ],
              },
        ]          },
        ],
      },

      {
        path: "customer-details",
        children: [
          {
            path: "",
            component: CustomerDetailsComponent,
          },
          {
            path: "customer-wallet-money",
            component: CustomerWalletMoneyComponent,
          },
          {
            path: "all-bookings",
            children: [
              {
                path: "",
                component: CustomersAllBookingsComponent,
              },
              {
                path: "booking-details",
                component: BookingDetailsPageComponent,
              },
            ],
          },

          {
            path: "all-payments",
            component: CustomerAllPaymentsComponent,
          },
          {
            path: "due-bookings",
            component: CustomersDueBookingsComponent,
          },
          {
            path: "reward-points",
            component: RewardPointsComponent,
          },
          // {
          //   path: 'unavailability',
          //   component: EntityUnavailabilityComponent
          // }
        ],
      },
      {
        path: "all-payments",
        component: CustomerAllPaymentsComponent,
      },
      {
        path: "due-bookings",
        component: CustomersDueBookingsComponent,
      },
      {
        path: "reward-points",
        component: RewardPointsComponent,
      },
      // {
      //   path: 'unavailability',
      //   component: EntityUnavailabilityComponent
      // }
    ],
  },
  {
    path: "all-members",
    children: [
      {
        path: "",
        component: AllMembersComponent,
      },
      {
        path: "all-payments",
        component: MembersAllPaymentsComponent,
      },
      {
        path: "due-payments",
        component: MembersDuePaymentsComponent,
      },
      {
        path: "member-details",
        children: [
          {
            path: "",
            component: MemberDetailsComponent,
          },
          {
            path: "tracking-item",
            children: [
              {
                path: "",
                component: TrackingItemsComponent,
              },
              {
                path: "tracking-item-details",
                component: TrackingItemsDetailsComponent,
              },
            ],
          },
          {
            path: "customer-wallet-money",
            component: CustomerWalletMoneyComponent,
          },
          {
            path: "all-payments",
            component: MembersAllPaymentsComponent,
          },
          {
            path: "due-payments",
            component: MembersDuePaymentsComponent,
          },
          {
            path: "view-attendance",
            component: ViewAttendanceComponent,
          },
          {
            path: "reward-points",
            component: RewardPointsComponent,
          },
        ],
      },
      {
        path: "view-attendance",
        component: ViewAttendanceComponent,
      },
      // {
      //   path: 'unavailability',
      //   component: EntityUnavailabilityComponent
      // }
    ],
  },

  {
    path: "new-booking",
    children: [
      {
        path: "",
        component: NewBookingComponent,
      },
    ],
  },
  {
    path: "all-bookings",
    children: [
      {
        path: "",
        component: NewShowAllComponent,
      },
      {
        path: "booking-details",
 children:[
          {
            path: '',
            component: BookingDetailsPageComponent,
          },
          {
                path: "customer-details",
                children: [
                  {
                    path: "",
                    component: CustomerDetailsComponent,
                  },
                  {
                    path: "customer-wallet-money",
                    component: CustomerWalletMoneyComponent,
                  },
                  {
                    path: "all-bookings",
                    children: [
                      {
                        path: "",
                        component: CustomersAllBookingsComponent,
                      },
                      {
                        path: "booking-details",//dont consider this in loop chain
                        component: BookingDetailsPageComponent,
                      },
                    ],
                  },

                  {
                    path: "all-payments",
                    component: CustomerAllPaymentsComponent,
                  },
                  {
                    path: "due-bookings",
                    component: CustomersDueBookingsComponent,
                  },
                  {
                    path: "reward-points",
                    component: RewardPointsComponent,
                  },
                  // {
                  //   path: 'unavailability',
                  //   component: EntityUnavailabilityComponent
                  // }
                ],
              },
        ]      },
      {
        path: "query-details",
        component: JoiningInterestDetailsComponent,
      },
      {
        path: "service-query-details",
        component: ServiceQueryDetailsPageComponent,
      },
    ],
  },

  {
    path: "employee-current-pack-recharge",
    children: [
      {
        path: "",
        component: EmployeeCurrentPackRechargeComponent,
      },
    ],
  },

  {
    path: "all-employees",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: NewEmployeesComponent,
      },
      {
        path: "employee-details",
        children: [
          {
            path: "",
            component: NewEmployeeDetailsComponent,
          },
          {
            path: "salary",
            component: EmployeeSalaryComponent,
          },
          {
            path: "salary-settings",
            component: EmployeeSalarySettingsComponent,
          },
          {
            path: "pay-credits",
            component: EmployeePayCreditsComponent,
          },
          {
            path: "duty-logs",
            component: EmployeeDutyLogsComponent,
          },
          {
            path: "access-control",
            component: AccessControlComponent,
          },

          {
            path: "current-plan",
            children: [
              {
                path: "",
                component: EmployeeCurrentPackRechargeComponent,
              },
              {
                path: "purchased-plan",
                children: [
                  {
                    path: "",
                    component: EmployeePurchasedPlanForRenewComponent,
                  },
                ],
              },
              {
                path: "plans-list",
                children: [
                  {
                    path: "",
                    component: EmployeePlansListForRenewComponent,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "purchased-plan",
        children: [
          {
            path: "",
            component: EmployeesPurchasedPlanComponent,
          },
        ],
      },
      {
        path: "plans-list",
        children: [
          {
            path: "",
            component: EmployeePlansListComponent,
          },
        ],
      },
      {
        path: "employee",
        children: [
          {
            path: "",
            component: NewAddNewEmployeeComponent,
          },
        ],
      },
    ],
  },

  // {
  //   path: 'new-employee-details',
  //   children: [
  //     {
  //       path: '',
  //       component: NewEmployeeDetailsComponent,
  //     },

  //   ],
  // },

  {
    path: "my-recharges",
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: NewRechargesComponent,
      },
    ],
  },
  {
    path: "employees-purchased-plan",
    children: [
      {
        path: "",
        component: EmployeesPurchasedPlanComponent,
      },
    ],
  },

  {
    path: "employee-plans-list",
    children: [
      {
        path: "",
        component: EmployeePlansListComponent,
      },
    ],
  },

  {
    path: "all-employee-log",
    children: [
      {
        path: "",
        component: AllEmployeeLogComponent,
      },
    ],
  },

  {
    path: "all-expenditure",
    children: [
      {
        path: "",
        component: AllExpenditureComponent,
      },
    ],
  },

  {
    path: "all-inventory-status",
    children: [
      {
        path: "",
        component: AllInventoryStatusComponent,
      },
    ],
  },

  {
    path: "all-latest-purchase",
    children: [
      {
        path: "",
        component: AllLatestPurchaseComponent,
      },
    ],
  },

  {
    path: "all-upcoming-appointments",
    children: [
      {
        path: "",
        component: AllUpcomingAppointmentsComponent,
      },
      {
        path: "booking-details",
 children:[
          {
            path: '',
            component: BookingDetailsPageComponent,
          },
          {
                path: "customer-details",
                children: [
                  {
                    path: "",
                    component: CustomerDetailsComponent,
                  },
                  {
                    path: "customer-wallet-money",
                    component: CustomerWalletMoneyComponent,
                  },
                  {
                    path: "all-bookings",
                    children: [
                      {
                        path: "",
                        component: CustomersAllBookingsComponent,
                      },
                      {
                        path: "booking-details",//dont consider this in loop chain
                        component: BookingDetailsPageComponent,
                      },
                    ],
                  },

                  {
                    path: "all-payments",
                    component: CustomerAllPaymentsComponent,
                  },
                  {
                    path: "due-bookings",
                    component: CustomersDueBookingsComponent,
                  },
                  {
                    path: "reward-points",
                    component: RewardPointsComponent,
                  },
                  // {
                  //   path: 'unavailability',
                  //   component: EntityUnavailabilityComponent
                  // }
                ],
              },
        ]      },
      {
        path: "membership-booking-details",
        children: [
          {
            path: "",
            component: MembershipBookingDetailsPageComponent,
          },
          {
            path: "tracking-item",
            children: [
              {
                path: "",
                component: TrackingItemsComponent,
              },
              {
                path: "tracking-item-details",
                component: TrackingItemsDetailsComponent,
              },
            ],
          },
          {
            path: "member-details",
            children: [
              {
                path: "",
                component: MemberDetailsComponent,
              },
              {
                path: "tracking-item",
                children: [
                  {
                    path: "",
                    component: TrackingItemsComponent,
                  },
                  {
                    path: "tracking-item-details",
                    component: TrackingItemsDetailsComponent,
                  },
                ],
              },
              {
                path: "customer-wallet-money",
                component: CustomerWalletMoneyComponent,
              },
              {
                path: "all-payments",
                component: MembersAllPaymentsComponent,
              },
              {
                path: "due-payments",
                component: MembersDuePaymentsComponent,
              },
              {
                path: "view-attendance",
                component: ViewAttendanceComponent,
              },
              {
                path: "reward-points",
                component: RewardPointsComponent,
              },
            ],
          },
        ],
      },
    ],
  },

  {
    path: "produce-bill",
    children: [
      {
        path: "",
        component: NewProduceBillComponent,
      },
    ],
  },

  {
    path: "current-pack-recharge",
    children: [
      {
        path: "",
        component: NewCurrentPackRechargeComponent,
      },
    ],
  },

  {
    path: "business-profile",
    children: [
      {
        path: "",
        component: BusinessProfileComponent,
      },
    ],
  },

  {
    path: "employees-profile",
    children: [
      {
        path: "",
        component: EmployeesProfileComponent,
      },
      {
        path: "invitation-details",
        component: EmployeeOnlyInvitationDetailsComponent,
      },
    ],
  },

  {
    path: "enroll-new-member",
    children: [
      {
        path: "",
        component: EnrollNewMemberComponent,
      },
    ],
  },

  {
    path: "**",
    redirectTo: "login",
  },
];
const routerOptions: ExtraOptions = {
  scrollPositionRestoration: "enabled", // or 'top'
  anchorScrolling: "enabled",
};
@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
